import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OnboardingInfos } from '@timechef/features/account/state/account.models';
import Swiper from 'swiper';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-onboarding-modal',
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.scss'],
  standalone: false,
})
export class OnboardingModalComponent {
  @Input() onboardingInfos: OnboardingInfos[] = [];
  @ViewChild(SwiperComponent) swiper?: SwiperComponent;

  sliderOptions = { initialSlide: 0 };
  swiperIsEnd = false;

  constructor(
    private modalCtrl: ModalController,
    private cd: ChangeDetectorRef,
  ) {}

  onSlideChangeTransitionEnd(swiper: [swiper: Swiper]) {
    this.swiperIsEnd = swiper[0].isEnd;
    this.cd.detectChanges();
  }

  slideNext() {
    if (this.swiper) {
      this.swiper.swiperRef.slideNext();
    }
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
